import { Logger } from '@frontend/logger';
import { jwtDecode } from 'jwt-decode';

import { Token } from './models';

interface JwtPayload {
    exp?: number;
}

export function getTokenExpirationMs(token: Token): number | null {
    if (token.token_expire_time) {
        const expirationTime = Date.parse(token.token_expire_time);
        if (!Number.isNaN(expirationTime)) {
            return expirationTime;
        }
    }

    try {
        const decoded = jwtDecode<JwtPayload>(token.jwt_token);
        if (decoded.exp) {
            return decoded.exp * 1000;
        }
    } catch (error) {
        Logger.error('Failed to decode JWT token for refresh scheduling:', error);
    }

    return null;
}
